import React, { useEffect, useState } from 'react';
import { Loader2, Timer, Radio } from 'lucide-react';

const mmss = (s) => `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;

// Card da fila de entrega: posição + CRONÔMETRO REGRESSIVO com a previsão (servidor) de quando a conta oficial
// entra na live do cliente. eta_at vem do servidor; aqui só contamos para trás (corrigindo o relógio do aparelho).
export const RpQueueCard = ({ queue }) => {
  const [left, setLeft] = useState(0);
  useEffect(() => {
    if (!queue?.eta_at) return undefined;
    const skew = Date.now() - new Date(queue.server_now).getTime(); // relógio do aparelho − servidor
    const tick = () => setLeft(Math.max(0, Math.round((new Date(queue.eta_at).getTime() + skew - Date.now()) / 1000)));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [queue?.eta_at, queue?.server_now]);
  if (!queue) return null;
  const running = queue.status === 'RUNNING';
  if (queue.status === 'WAITING_LIVE') {
    return (
      <div data-testid="rp-queue" data-status="WAITING_LIVE" className="mt-2 rounded-2xl border border-amber-400/70 bg-amber-500/15 px-3 py-2.5 text-left shadow-[0_0_18px_rgba(251,191,36,.3)]">
        <p className="flex items-center gap-2 text-[11px] font-black text-white" data-testid="rp-queue-waiting-live">
          <Radio className="h-4 w-4 animate-pulse text-amber-300" /> Abra sua live no KAKO para receber {queue.prizes} prêmio(s)
        </p>
        <p className="mt-0.5 text-[10px] text-amber-100/85">Assim que a live abrir, nossa conta entra, agradece no chat e entrega.</p>
      </div>
    );
  }
  return (
    <div data-testid="rp-queue" data-status={queue.status} data-position={queue.position}
      className={`mt-2 rounded-2xl border px-3 py-2.5 text-left ${running ? 'border-lime-400/70 bg-lime-500/15 shadow-[0_0_18px_rgba(163,230,53,.35)]' : 'border-sky-400/60 bg-sky-500/10'}`}>
      {running ? (
        <p className="flex items-center gap-2 text-[11px] font-black text-white" data-testid="rp-queue-running">
          <Radio className="h-4 w-4 animate-pulse text-lime-300" /> Nossa conta está na sua live agora — entregando {queue.prizes} prêmio(s). Fique na live!
        </p>
      ) : (
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="flex items-center gap-1.5 text-[11px] font-black text-white" data-testid="rp-queue-waiting">
              <Loader2 className="h-3.5 w-3.5 animate-spin text-sky-300" /> Fila de entrega · você é o <b className="text-sky-200">{queue.position}º</b>
            </p>
            <p className="text-[10px] text-purple-200/80">{queue.ahead > 0 ? `${queue.ahead} live(s) na frente · ` : 'Você é o próximo · '}previsão para entrarmos na sua live:</p>
          </div>
          <div className="shrink-0 rounded-xl border border-sky-400/50 bg-black/40 px-3 py-1.5 text-center" data-testid="rp-queue-timer">
            <p className="flex items-center gap-1 text-[9px] font-black uppercase tracking-widest text-sky-300"><Timer className="h-3 w-3" /> entra em</p>
            <p className="text-xl font-black tabular-nums text-white drop-shadow-[0_0_10px_rgba(56,189,248,.8)]" data-testid="rp-queue-countdown">{left > 0 ? mmss(left) : 'a qualquer momento'}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RpQueueCard;
